Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = PromptModal;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Modal = require('antd-mobile/lib/modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _closest = require('antd-mobile/lib/_util/closest');

var _closest2 = _interopRequireDefault(_closest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:no-switch-case-fall-through */
function PromptModal(title, message, callbackOrActions) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';
    var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var placeholders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ['', ''];
    var platform = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'ios';

    if (!callbackOrActions) {
        return {
            close: function close() {}
        };
    }
    var prefixCls = 'am-modal';
    var data = {};
    function onChange(e) {
        var target = e.target;
        var key = target.getAttribute('name');
        (!key||key==='')&&(key = target.getAttribute('type'))
        data[key] = target.value;
    }
    var inputDom = void 0;
    var focusFn = function focusFn(input) {
        setTimeout(function () {
            if (input) {
                input.focus();
            }
        }, 500);
    };
    switch (type) {
        case 'login-password':
            inputDom = _react2['default'].createElement(
                'div',
                { className: prefixCls + '-input-container' },
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'text', value: data.text, defaultValue: defaultValue, ref: function ref(input) {
                                return focusFn(input);
                            }, onChange: onChange, placeholder: placeholders[0] })
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'password', value: data.password, defaultValue: '', onChange: onChange, placeholder: placeholders[1] })
                    )
                )
            );
            break;
        case 'secure-text':
            inputDom = _react2['default'].createElement(
                'div',
                { className: prefixCls + '-input-container' },
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'password', value: data.password, defaultValue: '', ref: function ref(input) {
                                return focusFn(input);
                            }, onChange: onChange, placeholder: placeholders[0] })
                    )
                )
            );
            break;
        case 'number':
            inputDom = _react2['default'].createElement(
                'div',
                { className: prefixCls + '-input-container' },
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'number', value: data.number, defaultValue: defaultValue, ref: function ref(input) {
                                return focusFn(input);
                            }, onChange: onChange, placeholder: placeholders[0] })
                    )
                )
            );
            break;
        case 'modify-password':
            inputDom = _react2['default'].createElement(
                'div',
                { className: prefixCls + '-input-container' },
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'password', name: 'oldpwd', value: data.oldpwd, defaultValue: '', ref: function ref(input) {
                                return focusFn(input);
                            }, onChange: onChange, placeholder: placeholders[0] })
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'password', name: 'newpwd', value: data.newpwd, defaultValue: '', onChange: onChange, placeholder: placeholders[1] })
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'password', name: 'confirmpwd', value: data.confirmpwd, defaultValue: '', onChange: onChange, placeholder: placeholders[2] })
                    )
                )
            );
            break;
        case 'two-text':
            inputDom = _react2['default'].createElement(
                'div',
                { className: prefixCls + '-input-container' },
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'text', name: 'text', value: data.text, defaultValue: defaultValue.length>0?defaultValue[0]:'', ref: function ref(input) {
                                return focusFn(input);
                            }, onChange: onChange, placeholder: placeholders[0] })
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'text', name: 'text2', value: data.text2, defaultValue: defaultValue.length>1?defaultValue[1]:'', onChange: onChange, placeholder: placeholders[1] })
                    )
                )
            );
            break;
        case 'plain-text':
        case 'default':
        default:
            inputDom = _react2['default'].createElement(
                'div',
                { className: prefixCls + '-input-container' },
                _react2['default'].createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    _react2['default'].createElement(
                        'label',
                        null,
                        _react2['default'].createElement('input', { type: 'text', value: data.text, defaultValue: defaultValue, ref: function ref(input) {
                                return focusFn(input);
                            }, onChange: onChange, placeholder: placeholders[0] })
                    )
                )
            );
            break;
    }
    var content = _react2['default'].createElement(
        'div',
        null,
        message,
        inputDom
    );
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        _reactDom2['default'].unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    function getArgs(func) {
        if (type === 'number') {
            let number = data.number || defaultValue || 0;
            return func(number);
        } else if (type === 'login-password') {
            let text = data.text || defaultValue || '';
            let password = data.password || '';
            return func(text, password);
        } else if (type === 'secure-text') {
            let password = data.password || '';
            return func(password || defaultValue);
        } else if (type === 'modify-password') {
            let oldpwd = data.oldpwd || '';
            let newpwd = data.newpwd || '';
            let confirmpwd = data.confirmpwd || '';
            return func(oldpwd, newpwd, confirmpwd);
        } else if (type === 'two-text') {
            let text = data.text || defaultValue[0] || '';
            let text2 = data.text2 || defaultValue[1] || '';
            return func(text, text2);
        }
        var text = data.text || defaultValue || '';
        return func(text);
    }
    var actions = void 0;
    if (typeof callbackOrActions === 'function') {
        actions = [{ text: '取消' }, { text: '确定', onPress: function onPress() {
                getArgs(callbackOrActions);
            } }];
    } else {
        actions = callbackOrActions.map(function (item) {
            return {
                text: item.text,
                onPress: function onPress() {
                    if (item.onPress) {
                        return getArgs(item.onPress);
                    }
                }
            };
        });
    }
    var footer = actions.map(function (button) {
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    close();
                });
            } else {
                close();
            }
        };
        return button;
    });
    function onWrapTouchStart(e) {
        // exclude input element for focus
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = (0, _closest2['default'])(e.target, '.' + prefixCls + '-content');
        if (!pNode) {
            e.preventDefault();
        }
    }
    _reactDom2['default'].render(_react2['default'].createElement(
        _Modal2['default'],
        { visible: true, transparent: true, prefixCls: prefixCls, title: title, closable: false, maskClosable: false, transitionName: 'am-zoom', footer: footer, maskTransitionName: 'am-fade', platform: platform, wrapProps: { onTouchStart: onWrapTouchStart } },
        _react2['default'].createElement(
            'div',
            { className: prefixCls + '-propmt-content' },
            content
        )
    ), div);
    return {
        close: close
    };
}
module.exports = exports['default'];


// WEBPACK FOOTER //
// ./src/components/PromptModal.js